import Vue from 'vue'
import axios from 'axios'

// state
export const state = {
  all: {},
  isPrizesLoading: false,
}

// getters
export const getters = {
  getPrizesForSelectedRound: ({ all }, getters, { 'rounds/index': { selectedRoundId } }) => all[selectedRoundId] || [],
}
// mutations
export const mutations = {
  fetchPrizesStarted(state) {
    state.isRoundsLoading = true
  },
  fetchPrizesSuccess(state, { prizes, roundId }) {
    Vue.set(state.all, roundId, prizes)
    state.isPrizesLoading = false
  },
  fetchPrizesFailed(state) {
    state.isPrizesLoading = false
  },
}
// actions
export const actions = {
  async fetchPositionPrizes({ commit, rootState: { 'rounds/index': { selectedRoundId } } }, { roundId } = {}) {
    let currentRoundId = roundId
    if (!currentRoundId) {
      currentRoundId = selectedRoundId
      if (!currentRoundId) {
        return false
      }
    }
    let prizes = null
    try {
      commit('fetchPrizesStarted')
      prizes = await axios.get(`wins/roundPrizes/${currentRoundId}`)
      commit('fetchPrizesSuccess', { prizes, roundId: currentRoundId })
    } catch (e) {
      commit('fetchPrizesFailed')
    }
    return prizes
  },
}
